<template>
    <div class="placeholder">
        
        <div class="placeholder__heading">
            <d-tooltip placement="left" identifier="oekonomi.fordeling" />
            Fordeling mellem time- og vareforbrug (kostpriser)
        </div>
        
        <div class="placeholder padding" v-if="data && !loading && data.timeloggings.total > 0 && data.materials.total > 0">
            <div class="box">
                <div class="explainer bold">
                    <div class="timeloggings">
                        <i class="fas fa-clock fa-fw" />
                        Timer
                    </div>
                    <div class="materials">
                        Materialer
                        <i class="fas fa-wrench fa-fw" />
                    </div>
                </div>
                <div class="progress">
                    <div class="timeloggings" :style="'width:' + data.timeloggings.percent + '%;'" v-show="data" />
                    <div class="overlay">
                        <div class="timeloggings-percent">
                            {{ data.timeloggings.percent | rounded }} %
                        </div>
                        <div class="materials-percent">
                            {{ data.materials.percent | rounded }} %
                        </div>
                    </div>
                </div>
                <div class="explainer">
                    <div class="timeloggings">
                        {{ data.timeloggings.total | currency }}
                    </div>
                    <div class="materials">
                        {{ data.materials.total | currency }}
                    </div>
                </div>
            </div>
        </div>
        <box-loading height="350" v-else-if="!data && loading" />
        <div class="placeholder padding" v-else>
            Vi kunne ikke udregne fordelingen af udgifter. Tjek, at du har angivet hvilke medarbejdere, der skal regnes med i denne udregning. Dette kan du ændre i indstillinger under "Medarbejdere"
        </div>

    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .placeholder {
        height: fit-content;
    }

    .box {
        font-family: $fontfamily--main;

        .progress {
            height: 30px;
            width: 100%;
            background: rgba(0, 0, 0, 0.15);
            position: relative;
            margin: ($margin--small / 2) 0;
            border-radius: $borderradius--main;
            overflow: hidden;
            font-weight: 600;
            font-size: $fontsize--sm;
            font-family: $fontfamily--secondary;

            .timeloggings {
                background: $color--dark;
                display: block;
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
            }

            .overlay {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 ($padding--small / 2);

                .timeloggings-percent {
                    color: $color--white;
                }

                .materials-percent {
                    color: $color--dark;
                }
            }
        }

        .explainer {
            display: flex;
            justify-content: space-between;

            &.bold {
                font-weight: 600;
            }

            .small {
                // font-size: $fontsize--sm;
                margin-top: $margin--small / 2;
            }
        }
    }

</style>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            loading: false,
            data: null
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.data = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            economyService.costsDivision(params, (response) => {
                this.data = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// costsDivision.vue?4cee4ed4